import { createSlice } from "@reduxjs/toolkit";
import { getLeads } from "../reduxApi/leadReduxApi";

// const leadSlice = createSlice({
//     name: 'lead',
//     initialState: {
//         status: 'idel',
//         isFiltered: false,
//         lead: [],
//     },
//     reducers: {
//         setFilteredStatus: (state, action) => {
//             state.isFiltered = action.payload;
//         },
//         deleteLeadAction: (state, action) => {
//             action.payload.forEach((id) => {
//                 const index = state.lead.findIndex((item) => item.leads.ROWID === id);
//                 if (index !== -1) {
//                     state.lead.splice(index, 1);
//                 }
//             });
//         },
//         updateLeadAction: (state, action) => {
//             const index = state.lead.findIndex((item) => item.leads.ROWID === action.payload.ROWID)
//             if (index != -1) {
//                 state.lead.splice(index, 1, { leads: action.payload })
//             }
//         },
//         addLeadAction: (state, action) => {
//             const temp = action.payload.formData;
//             temp.ROWID = action.payload.ROWID;
//             state.lead.unshift({ leads: temp }); //add new data at beginning of array 
//         }
//     },
//     extraReducers: (builder) => {
//         builder.addCase(getLeads.pending, (state, action) => {
//             state.status = 'pending'
//         })
//             .addCase(getLeads.fulfilled, (state, action) => {
//                 state.status = 'fulfilled'
//                 state.lead = action.payload.data.response;
//                 state.count = action.payload.data.totalCount["COUNT(ROWID)"];
//             })
//     }
// })

const leadSlice = createSlice({
    name: 'lead',
    initialState: {
        status: 'idel',
        isFiltered: false,
        lead: [],
        count: 0,
        currentFilters: {} // Store current filters
    },
    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        setCurrentFilters: (state, action) => {
            state.currentFilters = action.payload;
        },
        deleteLeadAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.lead.findIndex((item) => item.leads.ROWID === id);
                if (index !== -1) {
                    state.lead.splice(index, 1);
                }
            });
        },
        updateLeadAction: (state, action) => {
            const index = state.lead.findIndex((item) => item.leads.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.lead.splice(index, 1, { leads: action.payload })
            }
        },
        addLeadAction: (state, action) => {
            const temp = action.payload.formData;
            temp.ROWID = action.payload.ROWID;
            state.lead.unshift({ leads: temp });
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getLeads.pending, (state, action) => {
                state.status = 'pending'
            })
            .addCase(getLeads.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                // Store the pre-filtered data from server
                state.lead = action.payload.data.response || [];
                state.count = action.payload.data.totalCount?.["COUNT(ROWID)"] || 0;
                
                // Update filtered status
                const hasSearchQuery = sessionStorage.getItem("leadSearchQuery");
                state.isFiltered = !!hasSearchQuery;
            })
            .addCase(getLeads.rejected, (state, action) => {
                state.status = 'rejected';
                state.lead = [];
                state.count = 0;
            })
    }
})


export const { deleteLeadAction, updateLeadAction, addLeadAction, setFilteredStatus } = leadSlice.actions
export default leadSlice.reducer



